import { useState } from "react";
import { Card } from "@material-ui/core";
import { Button, IconButton, Modal } from "@mui/material";
import api from "../../../../services/api";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";
import ButtonLeft from "../../../../utils/buttonLeft";
import Date from "../../../../utils/date";
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import { useParams } from "react-router-dom";
import AutorizacaoLote from "./documentosEmitidos/autorizacao/autorizacaoLotePdf";
import CertificadoAnaliticoPfd from "./documentosEmitidos/certificadoAnalitico/certificadoAnaliticoPDF";


export default function ApproveEmiteCertificadoAutorozacao({ solicitacaoAnalise, avaliacaoAnalitica, setAvaliacaoAnalitica }) {
    const dispatch = useDispatch()
    const { produtoId } = useParams()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [loadCertificado, setLoadCertificado] = useState(false);
    const [loadAutorizacao, setLoadAutorizacao] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const user = useSelector(state => state.account.user);

    // console.log(avaliacaoAnalitica) 
    const emitRCertificado = async () => {
        setLoadCertificado(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(relatorio)

        await api.patch('/avalicao-analitica/emit-certificado', {
            avaliacaoAnaliticaId: avaliacaoAnalitica?._id,
            userId: user?._id
        })
            .then(res => {
                // console.log(res)
                setMessageSuccess(res.data.msg)
                setAvaliacaoAnalitica(res.data.avaliacaoAnalitica)

                dispatch({
                    type: 'alert',
                    payload: { alert: 'Certificado emitido com sucesso' },
                });

            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setLoadCertificado(false))
    }

    const emitAutorizacao = async () => {
        setLoadAutorizacao(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(relatorio)

        await api.patch('/avalicao-analitica/emit-autorizacao', {
            avaliacaoAnaliticaId: avaliacaoAnalitica?._id,
            userId: user?._id
        })
            .then(res => {
                setMessageSuccess(res.data.msg)
                setAvaliacaoAnalitica(res.data.avaliacaoAnalitica)

                dispatch({
                    type: 'alert',
                    payload: { alert: 'Autorização emitido com sucesso' },
                });

            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setLoadAutorizacao(false))
    }

    return (
        <>
            <Button
                disabled={(produtoId && (user?.funcao === "Director Geral" || user?.funcao === "CNP")) ? false : true}
                fullWidth
                size="small"
                color="success"
                variant={"outlined"}
                onClick={() => setOpenModal(!openModal)}
            >
                Aprovar e Emitir Certificado e Autorização
            </Button>

            <Modal
                open={openModal}
                onClose={() => setOpenModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                // scroll={'body'}
                sx={{ margin: 2, overflowY: "auto" }}
            >
                <Card style={{ padding: 25, maxWidth: 800, margin: 'auto' }}>
                    {messageSuccess && <MessageSuccess message={messageSuccess} />}
                    {messageError && <MessageError message={messageError} />}

                    <HeaderGestorConfigs title={'Emitir Certificado'} />
                    <p>
                        <IconButton disabled={!avaliacaoAnalitica?.certificadoEmited} color="secondary"
                            onClick={() => { CertificadoAnaliticoPfd(avaliacaoAnalitica); }}
                        >
                            <DownloadOutlinedIcon />
                        </IconButton>
                        CERTIFICADO {avaliacaoAnalitica?.numero} _ <Date date={avaliacaoAnalitica?.certificadoEmitedAt} />
                    </p>
                    <ButtonLeft
                        disabled={avaliacaoAnalitica?.certificadoEmited}
                        title={'Emitir'}
                        funcao={emitRCertificado}
                        load={loadCertificado}
                    />


                    {solicitacaoAnalise?.status === 'Emissão do Certificado' &&
                        <>
                            <HeaderGestorConfigs title={'Emitir Autorização'} />
                            <p>
                                <IconButton disabled={!avaliacaoAnalitica?.autorizacaoEmited} color="secondary"
                                    onClick={() => { AutorizacaoLote(avaliacaoAnalitica); }}
                                >
                                    <DownloadOutlinedIcon />
                                </IconButton>
                                AUTORIZAÇĀO {avaliacaoAnalitica?.numero} _ <Date date={avaliacaoAnalitica?.autorizacaoEmitedAt} />
                            </p>

                            <ButtonLeft
                                disabled={avaliacaoAnalitica?.autorizacaoEmited}
                                title={'Emitir'}
                                funcao={emitAutorizacao}
                                load={loadAutorizacao}
                            />
                        </>
                    }

                </Card>
            </Modal>
        </>
    )
}